import type { CanFrame } from '../canlog/types';

export type LiveStats = {
  totalFrames: number;
  uniqueCanIds: number;
  estimatedFps: number;
  captureDurationMs: number;
  lastFrameTimestampMs: number | null;
};

export function buildLiveStats(frames: CanFrame[], startedAt: number | null): LiveStats {
  const unique = new Set(frames.map((frame) => frame.canId));
  const first = frames[0]?.timestampMs ?? null;
  const last = frames.at(-1)?.timestampMs ?? null;
  const durationFromFrames = first !== null && last !== null ? Math.max(0, last - first) : 0;
  const durationFromClock = startedAt === null ? 0 : Math.max(0, performance.now() - startedAt);
  const captureDurationMs = Math.max(durationFromFrames, durationFromClock);

  return {
    totalFrames: frames.length,
    uniqueCanIds: unique.size,
    estimatedFps: captureDurationMs > 0 ? frames.length / (captureDurationMs / 1000) : 0,
    captureDurationMs,
    lastFrameTimestampMs: last
  };
}
